import axios from "axios";

const BaseURL = process.env.REACT_APP_BASEURL;

const postData = async (url, formData, isAuthenticated, isAdmin) => {
    const headers = {
        // "Content-Type": "application/json",
        Accept: "application/json",
    };

    if (isAuthenticated) {
        const token = localStorage.getItem(isAdmin ? "adminAuth" : "token");
        headers.Authorization = `Token ${token}`;
    }
    try {
        const response = await fetch(`${BaseURL}/${url}`, {
            mode: "cors",
            method: "POST",
            headers: headers,
            body: formData,
        });

        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.log("Fetch error:", error.message);
    }
};

const postData1 = async (url, body, isAuthenticated, isAdmin) => {
    const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
    };

    if (isAuthenticated) {
        const token = localStorage.getItem(isAdmin ? "adminAuth" : "token");
        headers.Authorization = `Token ${token}`;
    }
    try {
        const response = await fetch(`${BaseURL}/${url}`, {
            mode: "cors",
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        });

        if (!response) {
            throw new Error(response.statusText);
        }
        const result = await response.json();
        return result;
    } catch (error) {

        // console.log("Fetch error:", error.message);
        throw error;
    }
};

export { postData, postData1 };


// medical departments 

export const createMedicalDepartment = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/medical-departments/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchMedicalDepartments = async (page = 1, pageSize = 10) => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/medical-departments/?page=${page}&page_size=${pageSize}`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const editMedicalDepartment = async (id, data) => {
    try {
        const response = await axios.put(
            `${BaseURL}/product/medical-departments/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteMedicalDepartment = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/medical-departments/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};

// department category 

export const createMedicalCategory = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/department-categories/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchMedicalCategories = async () => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/department-categories/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const editMedicalCategory = async (id, data) => {
    try {
        const response = await axios.put(
            `${BaseURL}/product/department-categories/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const deleteMedicalCategory = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/department-categories/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};

// Department SubCategory 

export const createMedicalSubCategory = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/subcategories/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const fetchMedicalSubCategories = async () => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/subcategories/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const editMedicalSubCategory = async (id, data) => {
    try {
        const response = await axios.put(
            `${BaseURL}/product/subcategories/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const deleteMedicalSubCategory = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/subcategories/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getSubcategoryById = async (id) => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/subcategories/${id}/get-subcategory-by-id/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const getDepartmentCategoryById = async (id) => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/department-categories/${id}/get-category-by-id/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const getSpecialityById = async (id) => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/speciality/${id}/get-specility-by-id/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};





export const suggestionSearch = async (query) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/product/autocomplete/`,
            {
                params: { q: query },
                headers: {
                    'accept': 'application/json'
                }
            }
        );
        return response.data;
    } catch (err) {
        return err;
    }
};

export async function postProductData(userDetails, formikValues,) {
    // console.log("in fo", formikValues)
    const { product_id, post_type } = userDetails;
    const url = `${process.env.REACT_APP_BASEURL}/product/product/add/`;

    const mergeOthers = {
        ...(formikValues?.others || {}),

        isDemoable: formikValues.isDemoable,
        askingPriceEnable: Boolean(formikValues?.askingPriceEnable),
        mrp: formikValues?.mrp || 0,
        warrantyMonth: formikValues?.warrantyMonth || 0,
        warrantyYear: formikValues?.warrantyYear || 0,
        hsn_code: formikValues?.hsn_code || ""
    };


    const formData = new FormData();
    const parseIds = (value) => {
        if (Array.isArray(value)) return value.filter((v) => v !== null && v !== undefined && String(v).trim() !== "");
        if (value === undefined || value === null) return [];
        return String(value)
            .split(",")
            .map((v) => v.trim())
            .filter((v) => v !== "")
            .map((v) => Number(v))
            .filter((n) => !Number.isNaN(n));
    };

    const deptIds = parseIds(formikValues.department_categories || formikValues.department_categories);
    const subCatIds = parseIds(formikValues.subcatory_lists || formikValues.subcategories);
    const specialityIds = parseIds(formikValues.specility_ids || formikValues.specialities);

    deptIds.forEach((id) => {
        formData.append("department_categories", String(id));
    });
    subCatIds.forEach((id) => {
        formData.append("subcategories", String(id));
    });
    specialityIds.forEach((id) => {
        formData.append("specialities", String(id));
    });


    // Scalar fields based on your curl
    formData.append("product_id", product_id);
    formData.append("post_type", post_type);
    formData.append("category_list", Array.isArray(formikValues.catog) ? formikValues.catog.join(",") : (formikValues.catog || ""));
    formData.append("speciality_name", Array.isArray(formikValues.spec) ? formikValues.spec.join(",") : (formikValues.spec || ""));
    formData.append("subcategory", Array.isArray(formikValues.subCategory) ? formikValues.subCategory.join(",") : (formikValues.subCategory || ""));

    formData.append("equip_name", formikValues.equpName || "");
    formData.append("description", formikValues.desc || "No description");
    formData.append("asking_price", formikValues.askPrice || "0.00");
    formData.append("equip_condition", formikValues.cond || "");
    formData.append("negotiable_type", formikValues.negotiableType || "");
    formData.append("year", parseInt(formikValues.mfYear) || "");
    formData.append("brand", formikValues.brand || "");
    formData.append("model", formikValues.model || "");
    formData.append("warranty", formikValues.warranty);
    formData.append("existing_amc", formikValues.amc);
    formData.append("other_details", formikValues.other);
    formData.append("shipping_form", formikValues.shipingFrom);
    formData.append("posted", formikValues.posted || new Date().toISOString().slice(0, 10));
    formData.append("visit", formikValues.visit || "none");
    formData.append("address", formikValues.address || "none");
    formData.append("seller_address", formikValues.seller_address || "");
    formData.append("latitude", formikValues.latitude || "");
    formData.append("longitude", formikValues.longitude || "");
    formData.append("status", "1");
    formData.append("product_status", "1");
    formData.append("installation_price", formikValues.installationPrice || "");
    formData.append("others", JSON.stringify(mergeOthers));
    formData.append("min_quantity", formikValues.min_quantity || 1);
    formData.append("rating", formikValues.rating === "" || formikValues.rating == null ? "" : String(formikValues.rating));
    formData.append("rating_count", formikValues.rating_count === "" || formikValues.rating_count == null ? "" : String(formikValues.rating_count));
    formData.append("seller_firstname", formikValues.sellerFname || "");
    formData.append("seller_lastname", formikValues.sellerLname || "");

    // Debug: Log what's being sent
    console.log("📤 FormData BEFORE SEND:", {
        subcategory: Array.isArray(formikValues.subCategory) ? formikValues.subCategory.join(",") : formikValues.subCategory,
        subcategories_ids: subCatIds,
        speciality_name: Array.isArray(formikValues.spec) ? formikValues.spec.join(",") : formikValues.spec,
        specialities_ids: specialityIds,
        category_list: Array.isArray(formikValues.catog) ? formikValues.catog.join(",") : formikValues.catog,
    });

    const headers = {
        'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
        'accept': 'application/json',
        // 'Content-Type' must not be manually set with FormData
    };

    try {
        const response = await axios.post(url, formData, { headers });
        // console.log('✅ Product data posted successfully!', response.data);
        return response.data;
    } catch (error) {
        console.error('❌ Error posting product data:', error.response?.data || error.message);
    }
}


export async function getSpecialityLists() {
    const url = `${process.env.REACT_APP_BASEURL}/product/speciality/lists/`;

    try {
        const response = await axios.post(url, {}, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return response.data; // Return the response JSON
    } catch (error) {
        console.error('Error fetching speciality lists:', error.message);
        return null;
    }
};



export const updateSpecialityList = async (id, data) => {
    const url = `${process.env.REACT_APP_BASEURL}/product/speciality/${id}/`;

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
    };

    try {
        const response = await axios.patch(url, data, { headers });
        // console.log("Success:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error updating speciality:", error.response?.data || error.message);
        throw error;
    }
};


export const deleteSpeciality = async (id) => {
    const url = `${process.env.REACT_APP_BASEURL}/product/speciality/${id}/`;

    const headers = {
        'Accept': 'application/json',
        'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
    };

    try {
        const response = await axios.delete(url, { headers });
        console.log("Speciality deleted successfully:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error deleting speciality:", error.response?.data || error.message);
        throw error;
    }
};

export const getCustomerOrder = async () => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/customer-orders/`,
            {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching customer orders:", error.message);
        throw error;
    }
};

// apis for seo meta

export const getSeoByref = async (id) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/seo-meta/by-reference/?reference_id=${id}`,
            {
                headers: {
                    //   'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching customer orders:", error.message);
        throw error;
    }
};

export const createSeo = async (seoData) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/seo-meta/`,
            seoData,
            {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating SEO meta:", error.response?.data);
        throw error;
    }
};
export const updateSeo = async (id, seoData) => {
    try {
        const response = await axios.put(
            `${process.env.REACT_APP_BASEURL}/product/seo-meta/${id}/`,
            seoData,
            {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating SEO meta:", error.response?.data);
        throw error;
    }
};

// extra details

export async function postProductDescription(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/product-description/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                    //   'X-CSRFTOKEN': 'L2oTch8rEhxmdXetjDGhbvITZUrzeVEE'
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('POST Error:', error.response?.data || error.message);
    }
}

export async function getProductDescriptionByProduct(type, productId) {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/product-description/by/${type}/${productId}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    //   'X-CSRFTOKEN': 'L2oTch8rEhxmdXetjDGhbvITZUrzeVEE'
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('GET Error:', error.response?.data || error.message);
    }
}

export async function updateProductDescriptionByProduct(type, id, data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BASEURL}/product/product-description/by/${type}/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                    //   'X-CSRFTOKEN': 'L2oTch8rEhxmdXetjDGhbvITZUrzeVEE'
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('POST Error:', error.response?.data || error.message);
    }
};

// activity logs 

export async function ActivityLogsData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function ActivityLogsRecentData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/recent/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function TimeAnalytics() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/daily-trend/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function AnalyticsStatsData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/stats/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function TopUsersData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/top-users/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function TypeSummeryData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/activitylog/type-summary/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function GeoIpData() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/geoip/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function GeoIpDataRecent() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/geoip/recent/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function GeoIpDataStats() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/geoip/stats/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function GeoTopCountries() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/geoip/top-countries/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function GeoTopCities() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/geoip/top-cities/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function getSlugByProduct(productId) {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/slug-url/by-product/${productId}/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function updateSlugByProduct(productId, data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BASEURL}/product/slug-url/${productId}/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function CreateSlugForProduct(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/slug-url/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function getHsnCode() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/hsn-code/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function getHsnCodeById(id) {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/hsn-code/${id}/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function postHsnCode(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/hsn-code/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function updateHsnCode(id, data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BASEURL}/product/hsn-code/${id}/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function dltHsnCode(id,) {
    try {
        const response = await axios.delete(
            `${process.env.REACT_APP_BASEURL}/product/hsn-code/${id}/`,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function reorderImages(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/update-image-order/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function postBanner(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/equip-banners/`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function putBanner(id, data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BASEURL}/product/equip-banners/?id=${id}`, data,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};
export async function getBanner() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/equip-banners/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function dltBanner(id) {
    try {
        const response = await axios.delete(
            `${process.env.REACT_APP_BASEURL}/product/equip-banners/?id=${id}`,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function postPartialPayment(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/product/partial-payments/`, data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function getPartialPayments() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/partial-payments/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export async function patchPartialPayment(id, data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BASEURL}/product/partial-payments/${id}/`, data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
        throw error;
    }
};

export async function deletePartialPayment(id) {
    try {
        const response = await axios.delete(
            `${process.env.REACT_APP_BASEURL}/product/partial-payments/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

// ---- User Analytics / Visitor Analytics ----

export async function fetchVisitorAnalytics(params = {}) {
    try {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== "" && value !== null && value !== undefined) {
                query.append(key, value);
            }
        });
        const qs = query.toString();
        const url = `${process.env.REACT_APP_BASEURL}/analytics/analytics-admin/visitors/${qs ? `?${qs}` : ""}`;

        const response = await axios.get(url, {
            headers: {
                'accept': 'application/json',
                'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching visitor analytics:', error.response?.data || error.message);
        throw error;
    }
}

export async function fetchVisitorActivity(params = {}) {
    try {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== "" && value !== null && value !== undefined) {
                query.append(key, value);
            }
        });
        const qs = query.toString();
        const url = `${process.env.REACT_APP_BASEURL}/analytics/analytics-admin/activity/${qs ? `?${qs}` : ""}`;

        const response = await axios.get(url, {
            headers: {
                'accept': 'application/json',
                'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching visitor activity:', error.response?.data || error.message);
        throw error;
    }
}

// ---- Dashboard Analytics (ECharts) ----

export async function fetchDashboardAnalytics(params = {}) {
    try {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== "" && value !== null && value !== undefined) {
                query.append(key, value);
            }
        });
        const qs = query.toString();
        const url = `${process.env.REACT_APP_BASEURL}/analytics/analytics-admin/dashboard/${qs ? `?${qs}` : ""}`;

        const response = await axios.get(url, {
            headers: {
                'accept': 'application/json',
                'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard analytics:', error.response?.data || error.message);
        throw error;
    }
}

// ---- Product Event & Traffic Analytics ----

export async function fetchProductEventAnalytics(params = {}) {
    try {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== "" && value !== null && value !== undefined) {
                query.append(key, value);
            }
        });
        const qs = query.toString();
        const url = `${process.env.REACT_APP_BASEURL}/analytics/analytics-admin/track-product-event/${qs ? `?${qs}` : ""}`;

        const response = await axios.get(url, {
            headers: {
                'accept': 'application/json',
                'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching product event analytics:', error.response?.data || error.message);
        throw error;
    }
}

export async function deleteContact(id) {
    try {
        const response = await axios.delete(
            `${process.env.REACT_APP_BASEURL}/contact/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};


export async function getTaxes() {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/product/taxes/`,

            {
                headers: {
                    'accept': 'application/json',
                    // 'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Get Error:', error.response?.data || error.message);
    }
};

export const getUnsubscribedEmails = async () => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/unsubscribed-email/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching unsubscribed emails:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteUnsubscribedEmail = async (id, email) => {
    const token = localStorage.getItem('adminAuth');
    try {
        if (id) {
            const response = await axios.delete(
                `${process.env.REACT_APP_BASEURL}/unsubscribed-email/${id}/`,
                {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Token ${token}`,
                    }
                }
            );
            return response.data;
        }
    } catch (error) {
        console.warn('DELETE by ID failed, trying resubscribe action fallback:', error.message);
    }

    if (email) {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/unsubscribed-email/resubscribe/`,
            { email },
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    }
};

export const addUnsubscribedEmail = async (email) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/unsubscribed-email/unsubscribe/`,
            { email },
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error adding unsubscribed email:', error.response?.data || error.message);
        throw error;
    }
};



